const playFromTypes = {
    PLAYLIST: {
        key: 'PLAYLIST',
        display: "Playlist"
    },
    SCHEDULE: {
        key: 'SCHEDULE',
        display: 'Schedule'
    },
    VIRTUAL_DJ: {
        key: 'VIRTUAL_DJ',
        display: 'Virtual DJ'
    },
    UNKNOWN: {
        key: 'UNKNOWN',
        display: 'Unknown'
    },
    NULL: {
        key:'NULL',
        display: 'N/A'
    }
}

export default playFromTypes;